// extracted by mini-css-extract-plugin
export default {"lds-ring":"LoadingComponent_lds-ring__ozPQK"};